import { useApiClient } from '@/composables/useApiClient'
import type {
  IAiCreditPurchaseCheckoutResponse,
  IAiCreditPurchaseCreatePayload,
  IAiCreditPurchaseStatusResponse,
  IAiCreditTokenPackage,
} from '@/services/payment/interfaces/payment.interface'

export const usePaymentService = () => {
  const privateApi = useApiClient(true)

  const createAiCreditPurchase = async (payload: IAiCreditPurchaseCreatePayload) => {
    return privateApi.post<IAiCreditPurchaseCheckoutResponse, IAiCreditPurchaseCreatePayload>(
      '/payments/checkout',
      payload,
    )
  }

  const getAiCreditTokenPackages = async () => privateApi.get<IAiCreditTokenPackage[]>('/payments/token-packages')

  const getAiCreditPurchase = async (purchaseOrderId: string) => {
    return privateApi.get<IAiCreditPurchaseStatusResponse>(`/payments/orders/${purchaseOrderId}`)
  }

  const downloadAiCreditInvoice = async (purchaseOrderId: string) => {
    return privateApi.get<Blob>(`/payments/orders/${purchaseOrderId}/invoice`, {
      responseType: 'blob',
    })
  }

  return {
    getAiCreditTokenPackages,
    createAiCreditPurchase,
    getAiCreditPurchase,
    downloadAiCreditInvoice,
  }
}
